import mixin from "../mixin";
import Axios from 'axios';
import _ from 'lodash';
import {
    MAIN_CONTRACT
} from '../utils/constants';
import ClipboardJS from 'clipboard';

const INIT_PRICE = '0.1000 EOS';

export default {
    name: "HelloWorld",
    mixins: [mixin],
    data() {
        return {
            title: '',
            avatar: '',
            desc: '',
            website: '',
            telegram: '',
            twitter: '',
            facebook: '',
            wechat: '',
            cost: '',
            modifier: '',
            hasInfo: false,
            status: '',
            activeName: 'recently',
            topList: [],
            interestList: [],
            relativeList: [],
            recentList: [],
            token: '',
            searchAccount: '',
            verified: '',
            searchList: [],
            searchAccountList: [],
            canInvite: false
        };
    },
    computed: {
        referralUrl: function () {
            return location.protocol + '//' + location.host + '/?refer=' + this.currentAccount;
        }
    },
    mounted() {
        new ClipboardJS('.copy-btn');
    },
    created() {
        this.waitingForLogin();
        this.getTopList();
        this.getRecentList();

    },
    methods: {
        clearSearch() {
            this.searchList = [];
            this.searchAccountList = [];
        },
        searchKeyUp(e) {
            if (e.keyCode == 13) {
                this.search();
            }
        },
        getInviteUrl() {
            this.$modal.show('invite');
        },
        waitingForLogin() {
            if (this.currentAccount) {
                this.getBaseInfo();
                this.getRelativeAccounts();
                this.getInterestAccounts();
            } else {
                setTimeout(this.waitingForLogin, 1000);
            }
        },
        // apply() {
        //     var actions = [{
        //         "account": MAIN_CONTRACT,
        //         "name": "applyverify",
        //         "authorization": [{
        //             "actor": this.currentAccount,
        //             "permission": this.currentPermission
        //         }],
        //         "data": {
        //             "account_name": this.currentAccount,
        //             "memo": '我是陈达，如何证明我是我？'
        //         }
        //     }]

        //     this.scatter.eosClient.transaction({
        //         actions
        //     }).then(res => {
        //         this.msg = "已提交";
        //         this.$modal.show("message");
        //     }).catch(err => {
        //         this.handleError(err);
        //     })
        // },
        getBaseInfo() {
            if (!this.currentAccount) {
                return;
            }

            this.canInvite = false;

            this.readonlyEos.getTableRows(true,
                MAIN_CONTRACT,
                MAIN_CONTRACT,
                "accounts",
                "",
                this.currentAccount,
                this.currentAccount,
                1).then(res => {
                    if (!!res.rows.length) {
                        let info = res.rows[0];
                        this.hasInfo = true;
                        this.title = info.title;
                        this.avatar = info.avatar;
                        this.desc = info.desc;
                        this.modifier = info.modifier;
                        this.status = info.status;

                        if (info.status === 3) {
                            this.canInvite = true;
                        }


                        this.cost = parseFloat(parseFloat(info.price) * 1.5).toFixed(4) + ' EOS';
                        this.verified = info.verified;
                        if (info.url) {
                            try {
                                let url = JSON.parse(info.url);
                                this.website = url.website;
                                this.telegram = url.telegram;
                                this.twitter = url.twitter;
                                this.wechat = url.wechat;

                            } catch (err) {
                                this.handleError(err);
                            }
                        }

                    } else {
                        this.hasInfo = false;
                        this.title = this.$t('i18nView.empty');
                        this.desc = this.$t('i18nView.empty');
                        this.modifier = this.$t('i18nView.empty');
                        this.avatar = '';
                        this.website = '';
                        this.telegram = '';
                        this.twitter = '';
                        this.wechat = '';
                    }
                })
        },

        search() {
            this.activeName = 'interest';

            if (_.includes(this.searchAccountList, this.searchAccount)) {
                return;
            }

            this.searchAccountList.push(this.searchAccount);

            this.readonlyEos.getAccount(this.searchAccount).then(res => {
                this.readonlyEos.getTableRows(true, MAIN_CONTRACT, MAIN_CONTRACT, 'accounts', '', this.searchAccount, this.searchAccount, 1).then(res => {
                    if (res.rows.length > 0) {
                        this.searchList.unshift(res.rows[0]);
                    } else {
                        this.searchList.unshift({
                            account_name: this.searchAccount,
                            avatar: "",
                            desc: "",
                            modifier: "",
                            price: "0",
                            status: 0,
                            title: "",
                            url: {},
                            verified: 0

                        })
                    }
                });
            }).catch(err => {
                this.msg = this.$t('i18nView.noSuchAccount');
                this.$modal.show("message");
            })

        },
        getTopList() {
            this.readonlyEos.getTableRows(true, MAIN_CONTRACT, MAIN_CONTRACT, 'accounts', '', '', '', 50, 'i64', 2).then(res => {
                this.topList = res.rows;
            })
        },
        getRecentList() {
            this.getRecentInfo();
        },

        getRecentInfo() {
            var queryUrl = "https://preserver.mytokenpocket.vip/v1/transaction_action/universal_list?account=account.info&blockchain_id=4&code=eosio.token&count=20&lang=zh-Hans&page=0&search=&sort=desc&symbol=EOS&type=1";
            Axios.get(queryUrl).then(res => {
                if (res.status === 200 && res.data.result === 0) {
                    var list = res.data.data;
                    var accountList = [];

                    list.forEach(tx => {
                        if (parseFloat(tx.quantity) >= 0.1) {
                            accountList.push(tx.from);
                        }
                    })

                    accountList = _.uniq(accountList);

                    if (accountList.length > 10) {
                        accountList.length = 10;
                    }

                    _.forEach(accountList, acc_name => {
                        this.readonlyEos.getTableRows(true,
                            MAIN_CONTRACT,
                            MAIN_CONTRACT,
                            "accounts",
                            "",
                            acc_name,
                            acc_name,
                            1).then(res => {
                                if (res.rows.length > 0) {
                                    this.recentList.push(res.rows[0]);
                                } else {
                                    this.recentList.push({
                                        account_name: acc_name,
                                        avatar: "",
                                        desc: "",
                                        modifier: "",
                                        price: "0",
                                        status: 0,
                                        title: "",
                                        url: {},
                                        verified: 0

                                    })
                                }
                            })
                    })


                }
            })
        },

        getRelativeAccounts() {
            this.readonlyEos.getTableRows(true, MAIN_CONTRACT, MAIN_CONTRACT, 'accounts', '', this.currentAccount, this.currentAccount, 100, 'name', 3).then(res => {
                this.relativeList = res.rows;
            });
        },
        getInterestAccounts() {
            this.getMyRecentRecords();
        },
        getMyRecentRecords() {
            var queryUrl = "https://preserver.mytokenpocket.vip/v1/transaction_action/universal_list?account=" + this.currentAccount + "&blockchain_id=4&code=eosio.token&count=50&lang=zh-Hans&page=0&search=&sort=desc&symbol=EOS&type=2";

            var relativeAccount = [];
            Axios.get(queryUrl).then(res => {
                if (res.status === 200 && res.data.result === 0) {
                    var list = res.data.data;
                    list.forEach(tx => {
                        relativeAccount.push(tx.to);
                    })

                    relativeAccount = _.uniq(relativeAccount);
                    if (relativeAccount.length > 10) {
                        relativeAccount.length = 10;
                    }

                    _.forEach(relativeAccount, acc_name => {
                        this.readonlyEos.getTableRows(true,
                            MAIN_CONTRACT,
                            MAIN_CONTRACT,
                            "accounts",
                            "",
                            acc_name,
                            acc_name,
                            1).then(res => {
                                if (res.rows.length > 0) {
                                    this.interestList.push(res.rows[0]);
                                } else {
                                    this.interestList.push({
                                        account_name: acc_name,
                                        avatar: "",
                                        desc: "",
                                        modifier: "",
                                        price: "0",
                                        status: 0,
                                        title: "",
                                        url: {},
                                        verified: 0

                                    })
                                }
                            })
                    })
                }
            })
        },
        handleClick() {

        },
        goInfo(account) {
            this.$router.push('/' + account);
        },
        goEdit() {
            this.$router.push('/edit/' + this.currentAccount);
        }

    }
};